import { IonIcon } from '@ionic/react';

export const DataEntry = ({ children, icon }) => (
  <div className="mt-5 flex items-center">
    <IonIcon icon={icon} className="text-primary text-xl mr-4" />
    {children ? (
      <span className="text-base text-white md:text-black" aria-hidden="true">
        {children}
      </span>
    ) : (
      <span
        className="w-32 h-4 bg-gray-700 md:bg-gray-100"
        aria-hidden="true"
      ></span>
    )}
  </div>
);
